import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./MicrophoneAccessModal.module.scss";
import {useMicrophoneAccessModalLogic} from "./MicrophoneAccessModal.logic";
import {GenericModal} from "../../common/genericModal/GenericModal";
import Button from "../../common/Button";

export interface IMicrophoneAccessModalProps {
  isOpen: boolean;
  close: () => void;
  onRequestMicAccessButton_click: () => void;
  open?: () => void;
}

export const MicrophoneAccessModal: VoidFunctionComponent<IMicrophoneAccessModalProps> = ({
  isOpen,
  close,
  onRequestMicAccessButton_click,
  open,
}) => {
  const {} = useMicrophoneAccessModalLogic();

  return (
    <GenericModal canShow={isOpen} title={`Microphone access ${open ? 'open' : ''}`}>
      <div className={s.container}>
        <div>
          The microphone on your device can be used to score the accuracy of your playing and provide instant feedback.
          <br/>
          Recordings do not leave your device and are deleted after scoring.
        </div>
        <Button
          text={"Request Mic Access"}
          buttonType={"secondary"}
          onClick={() => {
            onRequestMicAccessButton_click();
            close();
          }}>
        </Button>
        <Button
          text={"Cancel"}
          onClick={() => {
            close();
          }}
          buttonType={`primary`}>
        </Button>
      </div>
    </GenericModal>
  );
}
